<template>
  <div class="main">
    <headerNavbar title="文章资讯"></headerNavbar>
    <div class="article">
      <div class="article-cover"></div>
      <div class="article-title">{{article.title}}</div>
      <div class="article-author">
        <span class="author">{{article.author}}</span>
        <span class="release-time">发布于 {{article.update_time|fromNow}}</span>
      </div>
      <div class="article-content">
        <pre class="richtext" v-html="article.content"></pre>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .main {
    position: relative;
    background-color: #fff;
    min-height: 100vh;
  }

  .article {
    background-color: #fff;
    padding: 0 24px;
  }

  .article-title {
    font-size: 22px;
    font-weight: 500;
    word-wrap: break-word;
    color: rgba(0, 0, 0, 0.85);
    padding: 20px 0;
  }

  .article-author {
    padding-bottom: 16px;
    line-height: 20px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);

    .author {
      color: rgba(0, 0, 0, 0.65);
      font-size: 14px;
      margin-right: 12px;
    }

    .release-time {
      font-size: 13px;
      color: #b8bfc4;
    }
  }

  .article-content {
    font-size: 16px;
    line-height: 26px;
    padding: 16px 0;

    /deep/.richtext {
      white-space: pre-wrap;

      img {
        max-width: 100%;
      }

      table {
        width: 100%;
      }
    }
  }
</style>

<script>
  import headerNavbar from '../components/headerNavbar'
  import {
    getArticle
  } from "@/api/article";

  export default {
    components: {
      headerNavbar,
    },
    data() {
      return {
        article: {}
      };
    },
    mounted() {
      let hospId = this.$route.query.hospid;
      let id = this.$route.query.id;
      getArticle(hospId, id).then(res => {
        this.article = res.data;
      })
    },
  };
</script>